"use strict";

var _interopRequireDefault = require("/data/www/prod-cn-snote-cms/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addList = addList;
exports.aloneproduct = aloneproduct;
exports.changeOn = changeOn;
exports.changeproduct = changeproduct;
exports.deleproduct = deleproduct;
exports.getLists = getLists;
var _request = _interopRequireDefault(require("@/utils/request"));
//查询产品页banner图接口（cms系统调用调用）
function getLists(data) {
  return (0, _request.default)({
    url: 'cms/product/list',
    method: 'POST',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}

//添加产品购买接口
function addList(data) {
  return (0, _request.default)({
    url: 'cms/product',
    method: 'POST',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}

//上线、下线产品购买接口
function changeOn(data, id) {
  return (0, _request.default)({
    url: 'cms/product/line/' + id,
    method: 'put',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}

//查询单个产品购买接口
function aloneproduct(id) {
  return (0, _request.default)({
    url: 'cms/product/' + id,
    method: 'post',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    }
  });
}
//修改产品购买接口
function changeproduct(data, id) {
  return (0, _request.default)({
    url: 'cms/product/' + id,
    method: 'put',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}

//删除产品购买接口
function deleproduct(id) {
  return (0, _request.default)({
    url: 'cms/product/' + id,
    method: 'DELETE',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    }
  });
}